import { FC, useCallback } from 'react';

import { Upload } from '../../../assets';
import './styles.css';
import { IUploadFileWithDragZone } from './types';

export const UploadFileWithDragZone: FC<IUploadFileWithDragZone> = ({
  onUpload,
  text,
  title,
  filesConfigs,
}) => {
  const acceptedFormats = filesConfigs?.acceptedMimeTypes
    ?.map((mimeType) => mimeType.split('/')[1])
    ?.join(', ');
  const handleDrop = useCallback(
    (e: React.DragEvent) => {
      e.preventDefault();
      if (!e.dataTransfer.files.length) return;
      onUpload(Array.from(e.dataTransfer.files));
    },
    [onUpload],
  );

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files?.length) return;
    onUpload(Array.from(e.target.files));
    e.target.value = '';
  };

  const dragOverHandler = (e: React.DragEvent) => {
    e.preventDefault();
  };

  return (
    <div className="w-full" onDrop={handleDrop} onDragOver={dragOverHandler}>
      <label className="upload-area flex h-[180px] w-full cursor-pointer flex-col items-center justify-center rounded-[20px] border border-[transparent] bg-base-300">
        <input
          type="file"
          onChange={handleUpload}
          multiple
          className="hidden"
          accept={filesConfigs?.acceptedMimeTypes?.join(', ')}
        />
        <Upload className="mb-3 h-8 w-8" />
        <div className="text-center typography-16m">
          {title ?? 'Upload by click or drag'}
        </div>
        {(text || filesConfigs) && (
          <p className="mt-1 text-base-300 typography-14r">
            {text ??
              (filesConfigs &&
                `Max ${filesConfigs.maxFiles.toString()} files · ${acceptedFormats}`)}
          </p>
        )}
      </label>
    </div>
  );
};
